<script lang="ts">
  import FeatherIcon from "svelte-feather-icon";
  import LogoHeader from "./LogoHeader.svelte";
  import MaximizeIcon from "./MaximizeIcon.svelte";
  import SearchBar from "./SearchBar.svelte";
  import BookmarkIcon from "./BookmarkIcon.svelte";
  import NotificationIcon from "./NotificationIcon.svelte";
  import Modechanges from "./Darkmode.svelte";
  import MessageIcon from "./MessageIcon.svelte";
  import Logout from "./Logout.svelte";
  import { sidebarClose ,sidebarResponsive} from "../../store";
  import Language from "./Language.svelte";
  let closer: boolean;
  let sidebar:boolean
  let y:number
  // sidebar value change and close-open
  sidebarClose.subscribe((value) => {
    closer = value;
  });
  function handleclick(){
    sidebarResponsive.update(value => value = !value)
  }
  sidebarResponsive.subscribe((value:boolean)=>{
    sidebar = value
  }) 
</script>
<svelte:window bind:innerWidth={y} />
<div class={`page-main-header ${y < 992 ? (closer ? '' : 'close_icon') : closer ? 'close_icon' : ''}`}>
  <div class="main-header-right row m-0">
    <LogoHeader />
    <SearchBar />
    <div class="nav-right col pull-right right-menu p-0">
      <ul class={`nav-menus ${sidebar ? 'open' : ''}`}>
        <MaximizeIcon />
        <Language />
        <BookmarkIcon />
        <NotificationIcon />
        <Modechanges />
        <MessageIcon />
        <Logout />
      </ul>
    </div>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div class="d-lg-none mobile-toggle pull-right w-auto" on:click={handleclick}>
      <FeatherIcon icon="more-horizontal" />
    </div>
  </div>
</div>
